export const getServiceKindIcon = kind => {
  if (kind === 'IMPROVEMENTS') {
    return 'uil-plus-square'
  } else if (kind === 'CLEANING') {
    return 'uil-truck-loading'
  } else {
    return 'uil-refresh'
  }
}
